import { useState, useEffect } from 'react';
import { getPlatform, Platform } from '~/utils/client-utils';
import { useEvent } from '~/hooks/useEvent';

export const useAuth = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [platform, setPlatform] = useState<Platform>('web');
  const { sendEvent } = useEvent();

  // Use getPlatform utility to detect platform
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentPlatform = getPlatform();
      setPlatform(currentPlatform);
    }
  }, []);

  const loginWithGoogle = async () => {
    setIsLoading(true);
    try {
      // Add platform parameter for mobile apps
      const platformParam = platform !== 'web' ? `platform=${platform}` : '';
      const url = `${process.env.NEXT_PUBLIC_NESTJS_SERVER}/auth/google${
        platformParam ? `?${platformParam}` : ''
      }`;
      window.location.href = url;
    } catch (error) {
      console.error('Google login error:', error);
      sendEvent('login_failure', {
        method: 'google',
        error: (error as Error)?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loginWithApple = async () => {
    setIsLoading(true);
    try {
      // Add platform parameter if it's an iOS app
      const platformParam = platform !== 'web' ? `platform=${platform}` : '';
      const url = `${process.env.NEXT_PUBLIC_NESTJS_SERVER}/auth/apple${
        platformParam ? `?${platformParam}` : ''
      }`;
      window.location.href = url;
    } catch (error) {
      console.error('Apple login error:', error);
      sendEvent('login_failure', {
        method: 'apple',
        error: (error as Error)?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    loginWithGoogle,
    loginWithApple,
    platform,
  };
};
